import { SET_OFFERS } from '../utils/constants'

export const setOffers = (payload) => ({ type: SET_OFFERS, payload })
